<template>
  <v-footer
    dark
    height="auto"
    absolute
  >
    <v-card
      flat
      tile
      class="teal lighten-1 white--text text-xs-center"
    >
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon"
          class="white--text"
          icon
          @click="abrirLink(linkempresa)"
        >
          <v-icon >{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        Acesse uma das opções acima para entrar em contato com a gente.
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        &copy;2018 — <strong>Vuetify</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    props: ['linkempresa'],
    data: () => ({
      icons: [
        'check',
        'send'
      ]
    }),
    methods: {
        abrirLink(link) {
            window.open(link)
        },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/mensagens/layout/Footer.vue